import * as React from 'react';
import { Input } from 'antd';

import InputControlProps from '../InputControlProps';

export class TypeInput extends React.Component<InputControlProps> {
  render() {
    return (
      <Input
        style={{ minWidth: 200 }}
        onChange={(e) => this.props.onChange(e.target.value)}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
        value={this.props.value}
      />
    );
  }
}

export default TypeInput;
